var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7705 1.21094C16.1162 3.84932 16.875 6.83696 16.875 10.0018C16.875 13.1667 16.1162 16.1544 14.7705 18.7928C17.8856 17.0988 20 13.7972 20 10.0019C20 6.20649 17.8856 2.90497 14.7705 1.21094Z",
    fill: "#0BA5EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2738 0.997588C9.82152 0.356836 9.05099 0.0117544 8.27823 0.14586C3.57585 0.961912 0 5.06246 0 9.99819C0 14.9339 3.57583 19.0344 8.27819 19.8505C9.05095 19.9846 9.82148 19.6395 10.2738 18.9988C12.0699 16.4544 13.125 13.3495 13.125 9.99816C13.125 6.64687 12.0699 3.54199 10.2738 0.997588Z",
    fill: "#0086C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany04);
export default __webpack_public_path__ + "static/media/company-04.e4a5fb686b5cf2d26f6ba40c65d7ace0.svg";
export { ForwardRef as ReactComponent };